import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton, Dropdown, CircleProgressBar } from '@myplay/ui';
import { inject, observer } from 'mobx-react';

import { GREEN_LIGHT, WHITE, TURQUOISE } from '../../styles/colors';
import I18N from '../../I18N';
import { toTitleCase } from '../../utils/stringManipulations';
import { NAME } from '../../utils/constants';
import closeIcon from '../../assets/icons/Icon-Close.svg';
import { MYPLAY_SHARE_ROUTE } from '../../utils/constants';
import "./Live.scss";

class Live extends Component {

  static propTypes = {
    onClose: PropTypes.func, 
    onStartLive: PropTypes.func,
    siteName: PropTypes.string
  };

  static defaultProps = {
    onClose: ()=> {}, 
    onStartLive: ()=> {},
    siteName: ""
  };

  progressInterval = null;

  state = {
    selectedTeam: null,
    progress: 0,
    showProgress: false, 
    error: ""
  }

  handleTeamSelect = team => {
    this.setState({ 
      selectedTeam: team, 
      error: ""
    });
  };

  handleStartProgress = ()=> {
    this.setState({
      showProgress: true
    })
    this.progressInterval = setInterval(()=> {
      this.changeProgress()
    }, 1000)
  };

  handleClick = async ()=> {
    const { SitesStore: { startLive, stopLive }, site } = this.props;
    const { selectedTeam } = this.state;
    if (site.liveState.isLive) {
      await stopLive(site);
      return ;
    }

    if (selectedTeam) {
      this.handleStartProgress();
      await startLive(site, selectedTeam);
      return ;
    }

    return ;
  } 

  changeProgress = () => {
    const { site: { isLiveReady } } = this.props;
    const { progress } = this.state;

    if (isLiveReady) {
      clearInterval(this.progressInterval);
      this.progressInterval = setInterval(() => {
        this.changeProgress();
      }, 10);
    }

    if (progress < 100) {
      this.setState(prevState => ({ progress: prevState.progress + 1 }));
    } else {
      this.setState({showProgress: false});
      clearInterval(this.progressInterval);
    }
  };

  cancelLive = async ()=> {
    const { SitesStore: { stopLive }, site } = this.props;
    await stopLive(site);
    this.setState({ showProgress: false , progress: 0 });
    clearInterval(this.progressInterval);
  }

  handleSetError = ()=> {
    this.setState({
      error: toTitleCase(I18N.t("CHOOSE_TEAM_WARNING"))
    });
  };

  render() {
    const { site, TeamsStore, onClose } = this.props;
    const { showProgress, selectedTeam, progress, error } = this.state;
    const { name, liveState: { isLive, sessionId } } = site;
    const { teams } = TeamsStore;

    return (
      <div className="live" data-testid="live">
        {showProgress && progress ?
          <div className="live__progress-pie">
            <CircleProgressBar strokeWidth="8" progress={progress} />
            <div className="live__progress-pie__button-wrapper">
              <button type="button" onClick={this.cancelLive}>
                <span>{toTitleCase(I18N.t("CANCEL_LIVE"))}</span>
              </button> 
            </div>
          </div> :
          <Fragment>
            <button className="live__close-icon" type="button" onClick={onClose}>
              <img src={closeIcon} alt=""/>
            </button>
            <p>{name}</p>
            <div className="live__team-dropdown-wrapper">
              {!isLive &&
                <Dropdown 
                  placeholder={toTitleCase(I18N.t("CHOOSE_TEAM"))} 
                  items={teams} 
                  displayedProperty={NAME}
                  onSelect={this.handleTeamSelect}
                />
              }
            </div>
            {isLive &&
              <a className="live__link"  href={`${MYPLAY_SHARE_ROUTE}/public-live/${sessionId}`} target="_blank">
                {toTitleCase(I18N.t("GO_TO_LIVE"))}
              </a>
              } 
            <PrimaryButton 
              style={{ width: "130px" }} 
              color={WHITE} 
              background={selectedTeam || isLive ? GREEN_LIGHT : TURQUOISE} 
              onClick={selectedTeam || isLive ? this.handleClick : this.handleSetError}
              data-testid="live-button"
            >
              <span>
                {isLive ?
                  toTitleCase(I18N.t("STOP_LIVE")):
                  toTitleCase(I18N.t("START_GENERATING"))
                }
              </span> 
            </PrimaryButton>
            <span className="live__error">{error}</span>    
          </Fragment>
        }
      </div>
    );
  }
}

export default inject("TeamsStore", "SitesStore")(observer(Live));